import * as React from 'react';
import EmployeeReportTabPanel from './EmployeeReportTabPanel';
import { RouteComponentProps } from 'react-router';

export class EmployeeReport extends React.Component<RouteComponentProps<{}>, {}> {
    public render() {
        return <EmployeeReportTabPanel {...this.props} />
    }
}
